import { EmployeeLicenseWarning } from '../enums';

export class EmployeeLicenseSummaryWarning {
  warning: EmployeeLicenseWarning;

  total = 0;

  constructor(obj: any) {
    Object.assign(this, obj);
    this.warning = EmployeeLicenseWarning.byKey[obj.warning];
  }
}

export default EmployeeLicenseSummaryWarning;
